module.exports = __webpack_public_path__ + "assets/staff.77ea3e1a627dc3d1a8291eaf94cb745d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/services/staff.jpg
// module id = 313
// module chunks = 0